import React, { useMemo, useState } from "react";
import { authAPI } from "../services/api";
import "./AuthRecoveryPage.css";

const buildResetRedirectUrl = () => {
  if (typeof window === "undefined") return "";
  return `${window.location.origin}${window.location.pathname}#/reset-password`;
};

const ForgotPasswordPage = ({ onOpenSignIn }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const hasMessage = useMemo(() => Boolean(message), [message]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await authAPI.forgotPassword({
        email,
        redirectTo: buildResetRedirectUrl(),
      });

      setMessage(
        response?.data?.message
          || "If an account exists, a reset link has been sent to your email.",
      );
    } catch (requestError) {
      setError(
        requestError?.response?.data?.error
          || "Unable to send reset email right now.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth-recovery-page">
      <div className="auth-recovery-card">
        <h2>Forgot Password</h2>
        <p>
          Enter your account email and we&apos;ll send you a secure link to reset your password.
        </p>

        <form className="auth-recovery-form" onSubmit={handleSubmit}>
          <label htmlFor="forgot-email">
            Email
            <input
              id="forgot-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="name@episd.org"
              autoComplete="email"
              required
            />
          </label>

          {error ? <p className="auth-recovery-error">{error}</p> : null}
          {hasMessage ? <p className="auth-recovery-success">{message}</p> : null}

          <div className="auth-recovery-actions">
            <button type="submit" className="primary-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <button
              type="button"
              className="auth-recovery-link-btn"
              onClick={onOpenSignIn}
              disabled={loading}
            >
              Back to Sign In
            </button>
          </div>
        </form>

        <p className="auth-recovery-footnote">
          Check spam/junk if you do not see the message within a few minutes.
        </p>
      </div>
    </section>
  );
};

export default ForgotPasswordPage;
